import { CountUp } from 'use-count-up';
import { declOfNum } from '../../helpers';
import { useAppState } from '../../context/app';

import css from '../../styles/modules/favorites/FavoritesStatistic.module.scss';

const FavoritesStatistic = () => {
  /** STATES */
  const appState = useAppState();


  /** TEMPLATE */
  return (
    <>
      <section className={['block', css.statistic].join(' ')}>
        <div className="fixed">
          <div className={css.graph}>
            <div className={css.graphPie}>
              <span className={css.graphPieText}>
                <CountUp isCounting start={0} end={appState.history.length} duration={2} />
              </span>              
              <svg 
                  xmlns="http://www.w3.org/2000/svg"
                  width="120"
                  height="120"
                  viewBox="0 0 24 24"
                  fill="white"
                  stroke="currentColor"
                  strokeWidth="0.75"
                  strokeLinecap="round"
                  strokeLinejoin="round"
              >
                  <polygon points="12 1.77 15.67 8.03 22.76 9.59 17.94 15.01 18.65 22.23 12 19.32 5.35 22.23 6.06 15.01 1.24 9.59 8.33 8.03 12 1.77"/>
              </svg>
            </div>
            <div className={css.graphContent}>
              <div className={css.graphContentTitle}>Кол-во просмотров</div>
              <div className={css.graphContentDescription}>
                Такое количество просмотров Вы совершили у нас на сайте. Из них{' '}
                <b>только {new Set(appState.history).size}</b>{' '}
                {declOfNum(new Set(appState.history).size, [
                  'уникальный объект',
                  'уникальные объекты',
                  'уникальные объекты'
                ])}
                !
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default FavoritesStatistic;
